import dayjs from "dayjs";
import { OpeningTimes } from "reduxStore/services/api-v2/droppoints";

export const formatTimeCustom = (time: string, format: string) => {
  const hours = time.slice(0, 2);
  const minutes = time.slice(2, 4);
  return dayjs()
    .hour(parseInt(hours))
    .minute(parseInt(minutes))
    .second(0)
    .format(format);
};

export const formatTimeLong = (str: string) => {
  const hour = parseInt(str.slice(0, 2));
  const minute = parseInt(str.slice(2));
  const time = dayjs().hour(hour).minute(minute).second(0);

  return time.format("HH:mm:ss");
};

export const formatTime = (str: string) => { // time as hhmm e.g. 0730
  const hour = parseInt(str.slice(0, 2));
  const minute = parseInt(str.slice(2));
  const time = dayjs().hour(hour).minute(minute);
  const format = minute === 0 ? "ha" : "h:mma";

  return time.format(format);
};

export const formatOpeningTime = (times: [string, string] | null) => {
  return times
    ? formatTime(times[0]) + " to " + formatTime(times[1])
    : null;
};

export const formatOpeningTimes = (
  times: OpeningTimes,
  eveningTimes: OpeningTimes | null,
  includeEveningOpeningTimes: boolean,
  sep?: string
) => {
  if (!sep) {
    sep = "\n";
  }

  const days = [ "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun" ];

  const last = null;
  let startDay = null;
  let endDay = null;
  const lines = [];

  const formattedTimes = times.map(formatOpeningTime);

  const formattedEveningTimes = eveningTimes
    ? eveningTimes.map(time => time ? formatOpeningTime(time) : null)
    : [ null, null, null, null, null, null, null ];

  const allFormattedTimes = formattedTimes.map(function (span, i) {
    if (span && formattedEveningTimes[i] && includeEveningOpeningTimes) {
      return span + " & " + formattedEveningTimes[i];
    } else if (span) {
      return span;
    } else if (includeEveningOpeningTimes) {
      return formattedEveningTimes[i];
    }
  });

  for (let i = 0; i < allFormattedTimes.length; i++) {
    const time = allFormattedTimes[i];

    if (time) {
      const next = allFormattedTimes[i + 1];

      if (!startDay) {
        startDay = days[i];
      }

      if (next !== time) {
        endDay = days[i];

        const daySpan = startDay === endDay
          ? startDay
          : startDay + " - " + endDay;

        lines.push(daySpan + " " + time);

        startDay = null;
      }
    }
  }

  return lines.join(sep);
};

export const getOpeningTimeFormat = (openingTimes: OpeningTimes) => {
  if (
    openingTimes[0]
    && (JSON.stringify(openingTimes[0]) === JSON.stringify(openingTimes[1]))
    && (JSON.stringify(openingTimes[0]) === JSON.stringify(openingTimes[2]))
    && (JSON.stringify(openingTimes[0]) === JSON.stringify(openingTimes[3]))
    && (JSON.stringify(openingTimes[0]) === JSON.stringify(openingTimes[4]))
  ) {
    if (
      openingTimes[5] === null
      && openingTimes[6] === null
    ) {
      return "MON_FRI";
    }
    if (
      (JSON.stringify(openingTimes[0]) === JSON.stringify(openingTimes[5]))
      && (JSON.stringify(openingTimes[0]) === JSON.stringify(openingTimes[6]))
    ) {
      return "MON_SUN";
    }
  }
  return "CUSTOM";
};

const pad = (num: number) => {
  const str = "" + num;
  return str.length === 1 ? "0" + str : str;
};

const createOpeningTimeOptions = () => {
  const options = [];
  for (let h = 0; h <= 23; h++) {
    for (let m = 0; m < 60; m += 15) {
      options.push({
        value: pad(h) + pad(m),
        label: pad(h) + ":" + pad(m)
      });
    }
  }
  return options;
};

export const OPENING_TIME_OPTIONS = createOpeningTimeOptions();
export const DEFAULT_OPENING_TIMES: OpeningTimes = [
  [ "0900", "1700" ],
  [ "0900", "1700" ],
  [ "0900", "1700" ],
  [ "0900", "1700" ],
  [ "0900", "1700" ],
  null,
  null
];
